import React from 'react';
import { motion } from 'framer-motion';
import './AboutUsMission.css';

const AboutUsMission: React.FC = () => {

  return (
    <motion.section
      className="about-mission"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <div className="about-mission-container">
        <div className="about-mission-content">
          <h2 className="about-mission-title">
            Our Mission: <span className="highlight">Accelerating</span> Medical Breakthroughs
          </h2>
          <p className="about-mission-text">
            We're on a mission to accelerate the pace of medical discovery by eliminating the barriers that slow down clinical research. Through intelligent automation, seamless patient engagement, and real-time data insights, we empower researchers to focus on what matters most: bringing life-saving treatments to patients faster. Our AI-driven eCOA platform ensures that every data point collected is accurate, meaningful, and actionable.
          </p>
        </div>
        <div className="about-mission-visual">
          <img
            src="/crop-unrecognizable-worker-with-tablet-1024x683.webp"
            alt="Healthcare professional using advanced tablet technology"
            className="about-mission-img"
          />
        </div>
      </div>
    </motion.section>
  );
};

export default AboutUsMission;
